import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LucideAngularModule, CheckCircle, Info, X } from 'lucide-angular';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('300ms ease-in')),
      transition('active => removed', animate('300ms ease-out')),
    ]),
  ],
  preserveWhitespaces: false,
})
export class CustomToast extends Toast {
  readonly CheckCircle = CheckCircle;
  readonly Info = Info;
  readonly X = X;

  get icon() {
    if (this.toastPackage.toastType === 'toast-success') {
      return this.CheckCircle;
    }
    return this.Info;
  }

  get toastTitle() {
    return (
      this.toastPackage.title ||
      (this.toastPackage.toastType === 'toast-success' ? 'Success Message' : 'Error Message')
    );
  }
}
